import Link from 'next/link';

import {
  formatCatalogCharacterCount,
  formatCatalogFandomCount,
  formatListingCount,
  splitListingHeading,
} from '@/features/seo-listing/utils/seo-listing';

type SeoListingHeaderProps = {
  h1: string;
  worksCount: number | null;
  charactersCount?: number | null;
  charactersHref?: string;
  charactersCountSuffix?: string;
  worksCountSuffix?: string;
  fandomsCount?: number | null;
};

export function SeoListingHeader({
  h1,
  worksCount,
  charactersCount,
  charactersHref,
  charactersCountSuffix,
  worksCountSuffix,
  fandomsCount,
}: SeoListingHeaderProps) {
  const hasCharactersLink = Boolean(charactersHref);
  const hasCharactersCount = charactersCount != null && charactersCount > 0;
  const hasFandomsCount = fandomsCount != null && fandomsCount > 0;
  const charactersLabel = hasCharactersCount
    ? formatCatalogCharacterCount(charactersCount, charactersCountSuffix)
    : 'Персонажи';
  const charactersClassName =
    'inline-flex items-center rounded-full px-3 py-1 text-sm text-[#1B1D22] transition-colors hover:bg-[#505CFF]/10 dark:text-white';
  const heading = splitListingHeading(h1);
  return (
    <div className="mb-4 flex flex-wrap items-end gap-x-4 gap-y-1">
      <h1 className="text-[32px] font-black uppercase leading-[1.1] tracking-[-0.02em] text-[#1B1D22] dark:text-white sm:text-[40px]">
        {heading.label ? (
          <>
            <span className="font-medium">{heading.label} </span>
            <span className="font-black">{heading.name}</span>
          </>
        ) : (
          heading.name
        )}
      </h1>
      {worksCount != null || hasCharactersLink || hasCharactersCount || hasFandomsCount ? (
        <div className="flex flex-wrap items-center gap-2 pb-1 text-sm leading-[130%] tracking-[-0.01em] text-[#575E74]">
          {worksCount != null && hasFandomsCount ? (
            <p>
              <span className="font-bold">{formatListingCount(worksCount)}</span>{' '}
              <span className="font-medium">работ в {formatCatalogFandomCount(fandomsCount)}</span>
            </p>
          ) : worksCount != null ? (
            <p>
              <span className="font-bold">{formatListingCount(worksCount)}</span>{' '}
              <span className="font-medium">
                {worksCountSuffix ? `работ ${worksCountSuffix}` : 'работ'}
              </span>
            </p>
          ) : null}
          {hasCharactersLink ? (
            <Link href={charactersHref!} className={charactersClassName}>
              {charactersLabel}
            </Link>
          ) : hasCharactersCount ? (
            <span className={charactersClassName}>{charactersLabel}</span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
